module.exports = __webpack_public_path__ + "img/elementor-widget-icon.1387b427.svg";